import { render, staticRenderFns } from "./InternetPage.vue?vue&type=template&id=1aad6e28&"
import script from "./InternetPage.vue?vue&type=script&lang=js&"
export * from "./InternetPage.vue?vue&type=script&lang=js&"
import style0 from "./InternetPage.vue?vue&type=style&index=0&id=1aad6e28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports